export { default } from '@shikijs/langs/go'
